import React, { useContext } from 'react';
import { IEditorProps } from './Editor';
import { IPropertyChild } from 'components/property-editors/utils/ProviderNodeUtils';
import { ContextListPropertyNode } from '@decisions/server/DecisionsFramework/Design/Properties/ContextListPropertyNode';
import { EditorConfigButton } from './EditorConfigButton';
import { PropertyEditorContext } from 'components/property-editors/contexts/PropertyEditorContext';
import { ListBox } from '../lists/ListBox';
import { IListItemProps } from '../lists/ListItem';
import { EditorConfigButtons } from './EditorConfigButtons';
import { EditorLabel } from './EditorLabel';
import { getEditorConfigValue } from 'components/property-editors/utils/EditorConfigurationUtils';

export interface IDataDefinitionEditorProps extends IEditorProps {}

/**
 * DataDefinitions editor component
 *
 * Copyright (c) 2019 Decisions ALl Rights Reserved
 */
export function DataDefinitionsEditor({ child, path }: IDataDefinitionEditorProps) {
  const context = useContext(PropertyEditorContext);
  const onShowEditor = () => {
    context.onShowDialogue({
      node: child,
      editingContextId: context.editingContextId,
      path,
      options: {
        editInputs: getEditorConfigValue(child, 'EditInputs'),
      },
    });
  };

  const onDrop = (index: number) => {
    context.onQuickChange(child, {
      path,
      name: 'DROP',
      index,
    });
  };

  return (
    <EditorLabel editor={child} path={path} doNotWrap className="dpc-datadefinitions-editor">
      <ListBox items={getListItems(child)} onRemove={allowToEdit(child) ? onDrop : undefined} />
      <EditorConfigButtons>
        {allowToEdit(child) && <EditorConfigButton onClick={onShowEditor}>Show Editor</EditorConfigButton>}
      </EditorConfigButtons>
    </EditorLabel>
  );
}

function getListItems(child: IPropertyChild): IListItemProps[] {
  return (child.Node as ContextListPropertyNode).ItemLabels.map((label, index) => {
    return {
      label,
      index,
    } as IListItemProps;
  });
}

function allowToEdit(child: IPropertyChild): boolean {
  return !getEditorConfigValue(child, 'Readonly');
}
